module.exports = __webpack_public_path__ + "assets/img/save-history-icon-restore.e24e7356.svg";